<template>
  <Button
    v-bind="buttonProps"
    @click="handleOnClick"
    :class="[{ 'btn-paywall': !hasPermission }, $attrs.class]"
  >
    <template v-for="(_, slotName) of slots" v-slot:[slotName]="slotProps">
      <slot
        v-if="hasPermission || slotName !== 'iconRight'"
        :name="slotName"
        v-bind="slotProps ?? {}"
      ></slot>
    </template>
    <template v-if="!hasPermission && overrideIcon" #iconRight>
      <CadenasMinerve class="permission-level-icon" />
    </template>
  </Button>
</template>

<script setup lang="ts">
import { PermissionLevel } from "@follaw-fr/constants/enums/permission-level.enum";
import type { ButtonProps } from "@follaw-fr/components/reusable/atoms/Button.vue";
import Button from "@follaw-fr/components/reusable/atoms/Button.vue";

import { useUserSettingsStore } from "@follaw-fr/stores/user-settings";
import { computed } from "vue";
import CadenasMinerve from "@follaw-fr/components/reusable/minerve/CadenasMinerve.vue";
import { usePermissionGuard } from "@follaw-fr/composables/usePermissionGuard";

type ButtonWithPaywallProps = ButtonProps & {
  permissionLevel?: PermissionLevel;
  fallbackAction?: () => void;
  overrideIcon?: boolean;
};

const { permissionGuard } = usePermissionGuard();

const {
  permissionLevel = PermissionLevel.BASIC,
  fallbackAction = () => {},
  overrideIcon = true,
  ...buttonProps
} = defineProps<ButtonWithPaywallProps>();

const emit = defineEmits<{
  click: [];
}>();

const slots = defineSlots<{
  default: () => unknown;
  iconLeft: () => unknown;
  iconRight?: () => unknown;
}>();

const userSettingsStore = useUserSettingsStore();
const hasPermission = computed<boolean>(() =>
  userSettingsStore.hasPermission(permissionLevel)
);
const handleOnClick = (e: Event) => {
  permissionGuard({
    permissionLevel,
    action: () => emit("click"),
    fallBack: () => {
      e.stopPropagation();
      fallbackAction();
    },
  });
};
</script>

<style lang="scss">
.permission-level-icon {
  width: 12px;
}
.btn-paywall {
  opacity: 0.7;
}
</style>
